import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./portfolio-list-config-form.i18n";

type PortfolioListConfigFormProps = {
  flowLanguage: string;
  showAmount: boolean;
  onShowAmountChange: (show: boolean) => void;
  showFrequency: boolean;
  onShowFrequencyChange: (show: boolean) => void;
  showDates: boolean;
  onShowDatesChange: (show: boolean) => void;
};

export function PortfolioListConfigForm({
  flowLanguage,
  showAmount,
  onShowAmountChange,
  showFrequency,
  onShowFrequencyChange,
  showDates,
  onShowDatesChange,
}: PortfolioListConfigFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <div className="space-y-4 border rounded-lg p-4 bg-muted/30">
      <div>
        <Label className="text-base">{t.paymentDetails}</Label>
        <p className="text-xs text-muted-foreground mt-1">{t.paymentDetailsDesc}</p>
      </div>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="add-portfolio-list-show-amount">{t.showAmount}</Label>
            <p className="text-xs text-muted-foreground">{t.showAmountDesc}</p>
          </div>
          <Switch
            id="add-portfolio-list-show-amount"
            checked={showAmount}
            onCheckedChange={onShowAmountChange}
          />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="add-portfolio-list-show-frequency">{t.showFrequency}</Label>
            <p className="text-xs text-muted-foreground">{t.showFrequencyDesc}</p>
          </div>
          <Switch
            id="add-portfolio-list-show-frequency"
            checked={showFrequency}
            onCheckedChange={onShowFrequencyChange}
          />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="add-portfolio-list-show-dates">{t.showDates}</Label>
            <p className="text-xs text-muted-foreground">{t.showDatesDesc}</p>
          </div>
          <Switch
            id="add-portfolio-list-show-dates"
            checked={showDates}
            onCheckedChange={onShowDatesChange}
          />
        </div>
      </div>
    </div>
  );
}
